import { FlowType } from "@redotech/redo-model/return-flow";
import { z } from "zod";

export enum GetCurrentFlowErrorCode {
  RETURN_NOT_FOUND = "ReturnNotFound",
}

export const getCurrentFlow = {
  input: z.object({ flowType: z.enum(FlowType) }),
  output: z.object({ flow: z.any() }),
};
